import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LogAutorizacion } from 'src/app/shared/models/logAutorizacion';
import { TransferenciaDistribuidoresCabecera } from 'src/app/shared/models/transferenciaDistribuidoresCabecera';

import { AdmService } from 'src/app/shared/services/adm.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { LoggedService } from 'src/app/shared/services/logged.service';

import { isMobile, isMobileXL } from 'src/app/shared/utils/helpers';

@Component({
  selector: 'app-td-logs-dialog',
  templateUrl: './td-logs-dialog.component.html'
})
export class TDLogsDialogComponent {
  displayedColumns = ['fechaCreacion', 'estadoAnterior', 'estadoNuevo', 'nombreApellido', 'cargo', 'comentario'];
  dataSource = new MatTableDataSource<LogAutorizacion>();
  @ViewChild('matSort') matSort: MatSort;
  @ViewChild('matPaginator') matPaginator: MatPaginator;

  tdCab: TransferenciaDistribuidoresCabecera;

  constructor(

    private configService: ConfigService,
    private loggedService: LoggedService,
    private admService: AdmService,
    private dialogRef: MatDialogRef<TDLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    if (data.cab != null) {
  
      this.tdCab = data.cab;
    }

  }

  public Etiquetas: {

    EstadoAnterior: string,
    FechaCreacion: string,
    EstadoNuevo: string,
    NombreApellido: string,
    Cargo: string
    Comentario: string
    SinRegistros: string
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.matPaginator;
    this.dataSource.sort = this.matSort;
    this.dataSource.sort.disableClear = true;
  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(0));


    this.Etiquetas = {
      EstadoAnterior: this.configService.etiquetas.EstadoAnterior,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      EstadoNuevo: this.configService.etiquetas.EstadoNuevo,
      NombreApellido: this.configService.etiquetas.NombreApellido,
      Cargo: this.configService.etiquetas.Cargo,
      Comentario: this.configService.etiquetas.Comentario,
      SinRegistros: this.configService.etiquetas.SinRegistros
    }

    if (this.tdCab != null) {
      if (this.tdCab != null) {
        this.admService.cLogsAutorizaciones(this.tdCab.idPais, this.tdCab.idCompania, this.tdCab.idSalesOrg, this.tdCab.idDivision, this.tdCab.idTipoOrden, this.tdCab.nroPedido).subscribe((data: LogAutorizacion[]) => {

          this.dataSource.data = [];
          if (data != null) {
            this.dataSource.data = data;
          }

        });
      }

    }

  }


  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

}

